import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header/Header';
import ServiceDetailComponent from '../components/ServiceDetail/ServiceDetail';
import './ServiceDetailPage.css';

const ServiceDetail = () => {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      try {
        // Fetch all services and find the matching one by slug
        const res = await fetch('/api/services');
        const services = await res.json();
        
        // Find service matching the slug
        const found = services.find(s => {
          const serviceSlug = s.name?.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and') || '';
          return serviceSlug === slug;
        });

        if (found) {
          // Transform API data to match ServiceDetailComponent expected format
          setService({
            id: found.id,
            name: found.name,
            slug: slug,
            description: found.description || '',
            image: found.image_url || '',
            buttonText: found.button_text || 'Learn More',
            category: found.category_slug || 'residential',
            hero: {
              heading: found.name?.split('&')[0]?.trim() || 'Service',
              subheading: found.description || '',
              features: [
                { title: "Professional Service", desc: "Expert installation and setup" },
                { title: "Quality Guaranteed", desc: "100% satisfaction guaranteed" },
                { title: "Affordable Rates", desc: "Competitive pricing for all services" }
              ],
              details: found.description || 'Professional electrical service by Musa Electrical.'
            },
            products: [
              { name: "Equipment", image: "/images/supplier/image11.jpeg" },
              { name: "Accessories", image: "/images/supplier/image9.jpeg" },
              { name: "Tools", image: "/images/supplier/image12.jpeg" }
            ]
          });
        }
      } catch (err) {
        console.error('Failed to fetch service:', err);
      }
      setLoading(false);
    };

    fetchService();
  }, [slug]);

  if (loading) {
    return (
      <div className="page-wrapper">
        <Header />
        <div className="not-found">
          <h1>Loading...</h1>
        </div>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="page-wrapper">
        <Header />
        <div className="not-found">
          <h1>Service Not Found</h1>
          <Link to="/services">Back to Services</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="hero-wrapper">
        <Header />
        <div
          className="page-hero"
          style={{
            background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${service.image})`,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        >
          <div className="page-hero-content">
            <h1>{service.name}</h1>
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <a href="/services">Services</a>
              <span className="separator">/</span>
              <span className="active">{service.name}</span>
            </div>
          </div>
        </div>
      </div>

      <ServiceDetailComponent service={service} />
    </div>
  );
};

export default ServiceDetail;
